import { Component, h, Element, Event, EventEmitter, Method, State, Listen } from '@stencil/core';
import { PnkTabChange } from '../../enums/PnkTabChange';

export type CssClassMap = { [className: string]: boolean };

@Component({
  tag: 'pnk-tabs',
  styleUrl: 'pnk-tabs.css',
})
export class PnkTabs {
  @Element()
  el!: HTMLElement;

  @Event({ eventName: 'pnk-change' })
  onChange!: EventEmitter<PnkTabChange>;

  @State()
  tabs: HTMLPnkTabElement[] = [];

  componentWillLoad() {
    this.generateTabs();
  }

  generateTabs() {
    this.tabs = Array.from(this.el.querySelectorAll('pnk-tab'));
    if (this.tabs.length === 0) {
      throw new Error('[pnk-tabs] Must have at least one tab');
    }
  }

  @Method()
  async openTab(index: number) {
    if (index >= this.tabs.length) {
      throw new Error(`[pnk-tabs] Index ${index} is out of bounds of tabs length`);
    }
    if (!this.tabs[index].disabled) {
      this.tabs = this.tabs.map((tab, i) => {
        tab.active = i === index;
        return tab;
      });
      this.onChange.emit({ index, label: this.tabs[index].label, active: this.tabs[index].active });
    }
  }

  @Method()
  async updateTabs() {
    this.generateTabs();
  }

  @Listen('slotchange')
  handleSlotChange() {
    this.generateTabs();
  }

  render() {
    return (
      <div class="pnk-p-2 pnk-w-full pnk-h-full pnk-flex pnk-flex-col pnk-flex-1 pnk-overflow-hidden">
        <div class="pnk-flex pnk-flex-initial">
          {this.tabs.map((tab: HTMLPnkTabElement, index: number) => {
            const tabClassMap: CssClassMap = {
              'pnk-bg-disabled-base pnk-p-2 pnk-rounded-t-def enabled:hover:pnk-bg-white disabled:pnk-opacity-25 pnk-font-base pnk-text-base': !tab.active,
              'pnk-bg-white  pnk-pt-[15px] pnk-pb-2 pnk-pl-2 pnk-pr-2 pnk-rounded-t-[5px] pnk-outline-none pnk-font-base pnk-text-base': tab.active,
            };

            return (
              <button role="tab" disabled={tab.disabled} class={tabClassMap} onClick={() => this.openTab(index)}>
                {tab.label}
              </button>
            );
          })}
        </div>
        <div class="pnk-w-full pnk-h-full pnk-flex-auto pnk-overflow-hidden">
          <slot></slot>
        </div>
      </div>
    );
  }
}
